import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnHandMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M13.638 15.428h4.577c2.334 0 2.485 1.657 2.485 1.657l-9.748 3.75a2.49 2.49 0 0 1-2.004-.098l-5.647-2.823v-5.8h.828c.916 0 3.237.363 4.143 1.657h2.486a3.314 3.314 0 0 1 3.314 3.314h-5.8m10.77-7.042a2.071 2.071 0 1 1-4.142 0 2.071 2.071 0 0 1 4.143 0M12.416 5.07a2.071 2.071 0 1 1-4.143 0 2.071 2.071 0 0 1 4.143 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnHandMoney;
